module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (showBulkToolbar()) { 
__p+='\n			<td colspan="100" class="">\n				<div class="bulk-edit__row">\n					<div class="bulk-edit__inner">\n\n						<span>Apply</span> \n						<select class="js-bulk-action bulk-edit__action" name="type">\n						<option value="">Choose...</option>\n							';
 _.each(getBulkActions(), function(value, key) { 
__p+='\n							<option value="'+
((__t=( key ))==null?'':__t)+
'">'+
((__t=( value.label ))==null?'':__t)+
'</option>\n							';
 }) 
__p+='\n						</select>   \n						<span>to '+
((__t=( getBulkCount() ))==null?'':__t)+
' items? </span> \n						<span class="m-btn bulk-edit__apply js-apply-bulk">apply</span>\n					</div>\n				</div>\n			</td>\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/behaviors/bulk/templates/bulk-tools.html
// module id = 399
// module chunks = 0